import { j as o } from "./jsx-runtime-C5mzlN2N.js";
import n from "styled-components";
import "./components/Theme/themes.es.js";
import { r as f } from "./palettes-Bw24w7AF.js";
import { getSpacings as a, getPaletteBorder as u, getZIndexes as h, getEffects as l, getPaletteBackground as x, getRadii as d } from "./components/Theme/utils.es.js";
import "react";
import "./CssBaseline-Bp4jdUgb.js";
import { B as g } from "./ButtonClose-B4oX8Zuw.js";
import "./styles-DaQVIHg4.js";
import { T as c } from "./Typography-CGn3dGWy.js";
import { u as b, B as $ } from "./hooks-BmUDB8vC.js";
import { createPortal as v } from "react-dom";
import { backdropAnimations as m, contentAnimations as p } from "./components/BottomSheet/styles.es.js";
const y = n.div`
  display: flex;
  flex-direction: column;

  gap: ${a("xs")};
`, j = n.div`
  display: flex;
  flex-direction: row;

  padding: 0 ${a("xl")};

  gap: ${a("xl")};

  > :first-child {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;

    flex: 1;

    margin-top: ${a("3xl")};
  }

  > :last-child {
    align-self: flex-end;
  }
`, C = n.div`
  display: flex;
  flex-direction: row;

  padding: 0 ${a("xl")};
`, J = (t) => {
  const {
    title: e,
    message: i,
    className: r
  } = t, { onClose: s } = b();
  return /* @__PURE__ */ o.jsxs(y, { className: r, children: [
    /* @__PURE__ */ o.jsxs(j, { children: [
      /* @__PURE__ */ o.jsx(
        c,
        {
          variant: "text",
          weight: "semibold",
          color: "primary",
          size: "lg",
          children: e
        }
      ),
      /* @__PURE__ */ o.jsx(
        g,
        {
          size: "md",
          onClick: s
        }
      )
    ] }),
    i && /* @__PURE__ */ o.jsx(C, { children: /* @__PURE__ */ o.jsx(
      c,
      {
        variant: "text",
        weight: "regular",
        color: "tertiary",
        size: "sm",
        children: i
      }
    ) })
  ] });
}, B = n.div`
  display: flex;
  flex-direction: column;
  align-items:  flex-end;

  border-top: 1px solid ${u("secondary")};
  
  padding: ${a("xl")};
`, K = (t) => {
  const {
    className: e,
    children: i
  } = t;
  return /* @__PURE__ */ o.jsx(B, { className: e, children: i });
}, k = n.div`
  display: flex;
  flex-direction: column;

  padding: 0 ${a("xl")};
`, L = (t) => {
  const {
    className: e,
    children: i
  } = t;
  return /* @__PURE__ */ o.jsx(k, { className: e, children: i });
}, w = n.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  
  &[data-is-open='false'] {
    transition-property: visibility;
    transition-delay: 150ms;
    visibility: hidden;
  }

  z-index: ${h("modal")};
`, S = n.div`
  position: relative;
  width: 100%;
  height: 100%;
`, z = (t) => {
  const {
    isOpen: e,
    onClose: i,
    className: r,
    children: s
  } = t;
  return /* @__PURE__ */ o.jsx($.Provider, { value: {
    isOpen: e,
    onClose: i
  }, children: /* @__PURE__ */ o.jsx(
    w,
    {
      "data-is-open": e,
      className: r,
      children: /* @__PURE__ */ o.jsx(S, { children: s })
    }
  ) });
}, N = n.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  
  backdrop-filter: ${(t) => `blur(${l("blur.sm")(t)})`};
  -webkit-backdrop-filter:  ${(t) => `blur(${l("blur.sm")(t)})`};

  background-color: ${(t) => f(x("overlay")(t), 0.7)};

  animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  animation-duration: 150ms;

  &[data-is-open='true'] {
    animation-name: ${m.open};
  }

  &[data-is-open='false'] {
    animation-name: ${m.close};
  }
`, P = n.div`
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  
  background-color: ${x("primary.default")};
  border-top-left-radius: ${d("4xl")};
  border-top-right-radius: ${d("4xl")};

  animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  animation-duration: 150ms;

  &[data-is-open='true'] {
    animation-name: ${p.open};
  }

  &[data-is-open='false'] {
    animation-name: ${p.close};
  }
`, Q = (t) => {
  const {
    children: e,
    className: i,
    isOpen: r,
    onClose: s
  } = t;
  return v(
    /* @__PURE__ */ o.jsxs(
      z,
      {
        isOpen: r,
        onClose: s,
        className: i,
        children: [
          /* @__PURE__ */ o.jsx(
            N,
            {
              "data-is-open": r,
              onClick: s
            }
          ),
          /* @__PURE__ */ o.jsx(
            P,
            {
              "data-is-open": r,
              children: r && e
            }
          )
        ]
      }
    ),
    document.body
  );
};
export {
  J as B,
  K as a,
  L as b,
  Q as c
};
